// @ts-ignore
import badwords from "badwords/array";
import { useDocument } from "Utils/hooks/firestore";

export const useBadWords = () => {
  // Fails silently and will fallback to default list if not loaded on time
  const { data } = useDocument<{ words: string[] }>("enums/bad-words");
  return data?.words ? data.words.concat(badwords) : badwords;
};
